/**
 * Navigation — Leapfrog header
 *  - Mobile menu toggle (.nav-toggle → .mobile-menu)
 *  - Keyboard support for desktop dropdowns (.navdd)
 */

import { qs, qsa, throttle } from './utils.js';

export function initNavigation() {
	const header = qs( '.site-nav' ) || qs( 'header.site' );

	if ( ! header ) return;

	// ------------------------------------------------------------------
	// Mobile menu toggle
	// ------------------------------------------------------------------
	const toggle = qs( '.nav-toggle', header );
	const menu   = qs( '.mobile-menu', header );

	if ( toggle && menu ) {
		function openMenu() {
			toggle.setAttribute( 'aria-expanded', 'true' );
			menu.classList.add( 'is-open' );
		}

		function closeMenu() {
			toggle.setAttribute( 'aria-expanded', 'false' );
			menu.classList.remove( 'is-open' );
		}

		toggle.addEventListener( 'click', () => {
			const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
			isOpen ? closeMenu() : openMenu();
		} );

		// Close on Escape
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
				closeMenu();
				toggle.focus();
			}
		} );

		// Close on outside click
		document.addEventListener( 'click', ( e ) => {
			if ( ! header.contains( e.target ) && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
				closeMenu();
			}
		} );

		// Close on resize to desktop
		window.addEventListener( 'resize', throttle( () => {
			if ( window.innerWidth > 980 ) closeMenu();
		}, 200 ) );
	}

	// ------------------------------------------------------------------
	// Desktop dropdowns — click/keyboard support on top of CSS :hover
	// ------------------------------------------------------------------
	qsa( '.navdd', header ).forEach( ( dd ) => {
		const trigger = qs( '.navdd-t', dd );
		if ( ! trigger ) return;

		trigger.addEventListener( 'click', () => {
			const expanded = trigger.getAttribute( 'aria-expanded' ) === 'true';
			// Reset all triggers, then toggle this one
			qsa( '.navdd-t', header ).forEach( ( t ) => t.setAttribute( 'aria-expanded', 'false' ) );
			trigger.setAttribute( 'aria-expanded', String( ! expanded ) );
		} );
	} );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			qsa( '.navdd-t', header ).forEach( ( t ) => t.setAttribute( 'aria-expanded', 'false' ) );
		}
	} );
}
